import ClientConfig from "shared/config";
import {
  getApiKeyHeaders,
  getAuthorizationHeaders,
} from "shared/common/utils/general-utils";

// Enumeration for different provider types
export enum ProviderType {
  PILE = "pile",
  PILEGATE = "pilegate",
}

export interface FetchTenantNameResponse {
  id: string;
  name: string;
}

export const fetchTenantName = async (
  tenantID: string,
  accessToken: string
): Promise<FetchTenantNameResponse> => {
  const response = await fetch(
    `${ClientConfig.pilegateURL}tenants/${tenantID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getAuthorizationHeaders(accessToken),
        ...getApiKeyHeaders(),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status} ${response.statusText}`);
  }

  const data: FetchTenantNameResponse = await response.json();
  return data;
};

// Function to generate the URL for Pilegate requests
export function getPilegateURL(tenant: string, suffix = ""): string {
  // Construct and return the complete URL for the request
  return new URL(
    `tenants/${encodeURIComponent(tenant)}/projects/${suffix}`,
    ClientConfig.pilegateURL
  ).toString();
}

// Function for generating the URL and headers to wake up the lambda function
export function doWakeupRequest(): Promise<Response> {
  // Perform a GET request to wake up the lambda function
  const url = new URL("wakeup", ClientConfig.pilegateURL);
  return fetch(url.toString(), {
    method: "GET",
    headers: {
      ...getApiKeyHeaders(),
    },
  });
}
